import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  message: string;
};

export const ValidationErrorMessage: FC<Props> = ({ message }) => (
  <p className={styles.message}>{message}</p>
);
